import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { compose, defaultProps, withProps, lifecycle } from 'recompose';
import { scrollToElement } from '@sparefoot/react-core/utils/scrolling';

import { Link } from 'components/core/Link';
import { Review } from 'components/review/Review';

import './ReviewList.scss';

// Medium Padding + Sticky Search Height
const scrollOffset = 16 + 82;

export const enhance = compose(
	defaultProps({
		reviews: [],
		pageSize: 3,
		currentPage: 1,
	}),
	withProps(({ reviews, facility, pageSize, currentPage }) => ({
		visibleReviews: reviews
			.slice(pageSize * (currentPage - 1), pageSize * currentPage)
			.map((review) => (
				<Review
					key={review.id}
					review={review}
					facilityName={facility.name}
				/>
			)),
		facilityId: facility.id,
		prevUrl:
			currentPage - 1 >= 1
				? `${facility.url}?reviewPage=${currentPage - 1}`
				: null,
		nextUrl:
			currentPage + 1 <= Math.ceil(reviews.length / pageSize)
				? `${facility.url}?reviewPage=${currentPage + 1}`
				: null,
	})),
	lifecycle({
		UNSAFE_componentWillReceiveProps(nextProps) {
			if (this.props.currentPage !== nextProps.currentPage) {
				scrollToElement('.facility-reviews', {
					offset: -scrollOffset,
					behavior: 'smooth',
				});
			}
		},
	}),
);

export function ReviewList({ visibleReviews, prevUrl, nextUrl }) {
	return (
		<div className="review-list">
			<div className="reviews">{visibleReviews}</div>
			<div className="pagination">
				<Link
					className={classnames('previous', {
						disabled: !prevUrl,
					})}
					to={prevUrl}
					rel="nofollow"
				>
					Newer
				</Link>
				<Link
					className={classnames('next', {
						disabled: !nextUrl,
					})}
					to={nextUrl}
					rel="nofollow"
				>
					Older
				</Link>
			</div>
		</div>
	);
}

ReviewList.propTypes = {
	visibleReviews: PropTypes.arrayOf(PropTypes.node),
	nextUrl: PropTypes.string,
	prevUrl: PropTypes.string,
	facilityId: PropTypes.number,
};

export default enhance(ReviewList);
